/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  Box, Button,
  Container,
  IconButton,
  Stack,
  Pagination,
} from "@mui/material";
import { Refresh } from "@mui/icons-material";

import { Notification } from "components/Atoms";
import { H6 } from 'components/CustomTypography';

import * as Actions from "actions/seller/seller.orders";
import * as ActionTypes from "constants/ActionTypes";

import SellerOrder from "components/elements/seller/SellerOrder";
import SellerOrderEditor from "components/elements/seller/SellerOrderEditor";
import SellerOrderSelector from "components/elements/seller/SellerOrderSelector";
import MockProductList from "components/elements/main/MockProductList";
import UnifiedPullToRefresh from "components/elements/main/UnifiedPullToRefresh";

import { CURRENCY } from "config/constants";
import "./styles.scss";
import CustomFlexBox from "../../../../CustomFlexBox";
import UserProductStatusSelector from "../../../../elements/user/products/UserProductStatusSelector";
import ButtonComponent from "../../../../Button";

const OrdersMain = (props) => {
  const [state, setState] = useState({ orderMode: "PREVIEW" });
  const [orderState, setOrderState] = useState("");
  const [statusState, setStatusState] = useState("");
  const [typeState, setTypeState] = useState("");
  const [offsetState, setOffsetState] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const {
    serviceError, reqStatus, isLoading, storeOrders, symbol = "$", bootupInfo = {},
    getStoreOrders, includestatus, getOrderDetail, orderdetail, updateOrderStatus
  } = props;

  useEffect(() => {
    getStoreOrders(statusState, typeState, 1);
  }, []);

  const handleRefresh = () => {
    getStoreOrders(statusState, typeState, offsetState);
  };

  const sendNotification = (type, { title, description = "" }) => {
    Notification[type]({
      message: title,
      description,
    });
  };

  useEffect(() => {
    if (serviceError && reqStatus) {
      const feedback = {
        title: "Something went wrong!",
        description: serviceError.statusText,
      };
      sendNotification("error", feedback);
    }
    switch (reqStatus) {
      case ActionTypes.UPDATE_ORDER_STATUS_SUCCESS:
        //getStoreOrders(props.orderstatus, props.ordertype);
        getStoreOrders(statusState, typeState, offsetState);
        break;
      default:
        break;
    }
  }, [serviceError, reqStatus]);


  const setOrderStatus = (status) => {
    setStatusState(status);
    getStoreOrders(status, typeState, offsetState);
  };

  const setOrderType = (type) => {
    setTypeState(type);
    getStoreOrders(statusState, type, 1);
  };

  const editOrder = (order) => {
    updateOrderStatus(order);
    setState({ orderMode: "PREVIEW" });
  };

  const handleOrderEdit = (mode, order, reset) => () => {
    setState({ orderMode: mode });
    if (reset) {
      setOrderState({
        selectedOrder: {
          order_id: "", _id: "", status: "", order_type: "", user: "",
        },
      });
    } else {
      props.getSellerOrderDetail(order._id);
      setOrderState({
        selectedOrder: {
          order_id: order.order_id, _id: order._id, status: order.status, order_type: order.order_type, user: order.user,
        },
      });
    }
  };

  const handlePage = (page) => (e) => {
    props.history.push({
      pathname: page,
    });
  };

  const handlePrevOffset = () => {
    const offset = offsetState > 1 ? offsetState - 1 : 1;
    setOffsetState(offset);
    getStoreOrders(statusState, typeState, offset);
  };

  const handleNextOffset = () => {
    const offset = offsetState + 1;
    setOffsetState(offset);
    getStoreOrders(statusState, typeState, offset);
  };

  const handlePageChange = (event, value) => {
    setOffsetState(value);
    getStoreOrders(statusState, typeState, value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const { orderMode } = state;
  const { selectedOrder = {} } = orderState;
  const { records, pagination } = storeOrders;

  const renderNoResults = () => (
    <section className="cart-section section-b-space">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div>
              <div className="col-sm-12 empty-cart-cls text-center">
                <H6>No order found
                </H6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  const renderResults = () => (
    records.map((order) => (
      <SellerOrder
        className="product-item"
        key={order._id}
        order={order}
        editOrderStatus={handleOrderEdit("EDIT", order, false)}
      />
    ))
  );

  const renderOrderList = () => (
      <Box mt={2} sx={{ width: "100%", paddingBottom: '100px' }}>

        <Box mt={2}>
        </Box>
        
      {includestatus === true ?
      <SellerOrderSelector handlePage={handlePage} onTypeSelect={setOrderType} onStatusSelect={setOrderStatus} orderstatus={statusState} ordertype={typeState} /> : ""
      }

        <CustomFlexBox alignItems="center" mt={2} mb={2} sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
        }}>
          <Box width="100%">
            <IconButton onClick={handleRefresh} disabled={isLoading} sx={{ ml: 1 }}>
              {isLoading ? <Refresh sx={{ animation: 'spin 1s linear infinite', '@keyframes spin': { '0%': { transform: 'rotate(0deg)' }, '100%': { transform: 'rotate(360deg)' } } }} /> : <Refresh />}
            </IconButton>
          </Box>
        </CustomFlexBox>

      {isLoading ? <MockProductList />
        : records.length > 0
          ? renderResults()
          : renderNoResults()}

      {/* Pagination */}
      {!isLoading && records.length > 0 && pagination && pagination.totalPages > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 2, width: '100%' }}>
          <Stack spacing={2}>
            <Pagination
              count={pagination.totalPages || 1}
              page={offsetState || 1}
              onChange={handlePageChange}
              color="primary"
              size="large"
            />
          </Stack>
        </Box>
      )}
      </Box>
  );

  const renderOrderEdit = (orderMode) => {
    switch (orderMode) {
      case "EDIT":
        return (
          <SellerOrderEditor
              setState={(value, field) => setOrderState({
                ...state,
                selectedOrder: {
                  ...selectedOrder,
                  [field]: value,
                },
              })}
              symbol={symbol}
              isLoading={isLoading}
              orderdetail={orderdetail}
              selectedOrder={selectedOrder}
            updateOrderClicked={editOrder}
            onCancel={() => setState({ orderMode: "PREVIEW" })}
          />
        );
      case "EDIT_SET":
      default:
        return (
            <SellerOrderEditor
                setState={(value, field) => setOrderState({
                  ...state,
                  selectedOrder: {
                    ...selectedOrder,
                    [field]: value,
                  },
                })}
                symbol={symbol}
                isLoading={isLoading}
                orderdetail={orderdetail}
                selectedOrder={selectedOrder}
                updateOrderClicked={editOrder}
                onCancel={() => setState({ orderMode: "PREVIEW" })}
            />
        );
    }
  };

  return (
    <UnifiedPullToRefresh
      onRefresh={handleRefresh}
      isRefreshing={isLoading}
    >
      <Container>
        {orderMode === "PREVIEW" ? (
          renderOrderList()
        ) : (
          renderOrderEdit(orderMode)
        )}
      </Container>
    </UnifiedPullToRefresh>
  );
};

OrdersMain.defaultProps = {
  isLoading: false,
  serviceError: "",
  reqStatus: "",
  storeOrders: [],
  symbol: CURRENCY,
  includestatus: true,
};

OrdersMain.propTypes = {
  isLoading: PropTypes.bool,
  serviceError: PropTypes.string,
  reqStatus: PropTypes.string,
  storeOrders: PropTypes.arrayOf(PropTypes.object),
  symbol: PropTypes.string,
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  getStoreOrders: PropTypes.func.isRequired,
  updateOrderStatus: PropTypes.func.isRequired,
};

const ordersMain = connect(
  ({ orders, bootupInfo }) => ({
    bootupInfo,
    symbol: bootupInfo.symbol,
    reqStatus: orders.reqStatus,
    isLoading: orders.isLoading,
    serviceError: orders.serviceError,
    storeOrders: orders.storeOrders,
    orderdetail: orders.orderdetail,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(OrdersMain);

export default ordersMain;
